import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = require('./spinner.module.scss')

export const Spinner: React.SFC<{}> = () => {
    return (
        <div className={styles.overlay}>
            <CircularProgress style={{ width: 50, height: 50 }} />
        </div>
    )
}
